import { render, staticRenderFns } from "./InfoBanner.vue?vue&type=template&id=4588eaf0&scoped=true&"
import script from "./InfoBanner.vue?vue&type=script&lang=js&"
export * from "./InfoBanner.vue?vue&type=script&lang=js&"
import style0 from "./InfoBanner.vue?vue&type=style&index=0&id=4588eaf0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4588eaf0",
  null
  
)

export default component.exports